import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { TextField, Button, FormControl, Box } from "@mui/material";
import Alert from "@mui/material/Alert";
import TripPort from "../../../components/TripPort";

function NewTripForm2({ nextStep, handleChange, values }) {
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const _next = (event) => {
    event.preventDefault();
    if (Object.keys(values.portcd).length === 0) {
      setErrors({ port: "Departure Port is required." });
      return;
    }
    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    navigate(`${process.env.PUBLIC_URL}/ivr`, {
      state: { trip_id: values.vtr_nbr, vesselNbr: values.permitNbr },
    });
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <FormControl variant="standard">
          <TextField
            name="trip_id"
            label="Trip Id:"
            className="number-of-input"
            type="number"
            placeholder="Trip Id"
            variant="standard"
            value={values.tripid}
            onChange={handleChange("trip_id")}
            required={true}
            inputProps={{ style: { textAlign: "center" } }}
          />
        </FormControl>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <TripPort
          id="port"
          name="port"
          label="Departure Port"
          value={values.portcd}
          onChange={handleChange("port")}
        />
      </Box>
      {errors.port && <Alert severity="error">{errors.port}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Cancel
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default NewTripForm2;
